// extracted by css-extract-rspack-plugin
var _1 = "WaFZjezI2wlJqekO";
var _2 = "MZBtKVj8Zr0YZQNa";
var _3 = "MZBtKVj8Zr0YZQNa";
var _4 = "mtAUAIH4MQm0yxml";
var _5 = "mtAUAIH4MQm0yxml";
var _6 = "VwEn8tWO40G2XUM9";
var _7 = "VwEn8tWO40G2XUM9";
var _8 = "STyhXGSMivMJk3B2";
var _9 = "D5rqIqVw6RQOnlOR";
var _a = "QCtgVRPVIMExyGfw";
var _b = "CyQ2ZO3kBocKgIH1";
var _c = "Ma6nVBEFkocs_UVw";
var _d = "esiU2LM6MkNwCLxw";
var _e = "OOMPzIfK0pcLoQje";
var _f = "STyhXGSMivMJk3B2";
var _10 = "D5rqIqVw6RQOnlOR";
var _11 = "QCtgVRPVIMExyGfw";
var _12 = "CyQ2ZO3kBocKgIH1";
var _13 = "Ma6nVBEFkocs_UVw";
var _14 = "esiU2LM6MkNwCLxw";
var _15 = "OOMPzIfK0pcLoQje";
var _16 = "x8LxTTnGZt8WTnX8";
export { _1 as "container", _2 as "footer-sponsors", _3 as "footerSponsors", _4 as "local-sponsors", _5 as "localSponsors", _6 as "presented-by", _7 as "presentedBy", _8 as "sponsor-bar", _9 as "sponsor-item", _a as "sponsor-item__img", _b as "sponsor-item__name", _c as "sponsor-item__wrap", _d as "sponsor-label", _e as "sponsor-list", _f as "sponsorBar", _10 as "sponsorItem", _11 as "sponsorItemImg", _12 as "sponsorItemName", _13 as "sponsorItemWrap", _14 as "sponsorLabel", _15 as "sponsorList", _16 as "title" }
